import { SocialLogin } from '@capgo/capacitor-social-login';
import { EnvironmentService, GapiService } from '../contracts';

export class AndroidGapiService implements GapiService {
  private readonly _initializationPromise: Promise<void>;

  constructor(private readonly _environment: EnvironmentService) {
    this._initializationPromise = SocialLogin.initialize({
      google: {
        webClientId: this._environment.googleClientId,
        mode: 'offline'
      }
    });
  }

  async grantOfflineAccess(scopes: string[]): Promise<string> {
    await this._initializationPromise;

    const { result } = await SocialLogin.login({
      provider: 'google',
      options: {
        scopes: scopes
      }
    });

    if (result.responseType === 'offline') {
      return result.serverAuthCode;
    } else {
      throw new Error('Invalid Google response type');
    }
  }
}
